// This file is AUTOGENERATED, do not edit it manually!!!

import { errors as errorsde } from './errorsResx.de';
import { errors as errorsen } from './errorsResx.en';
import { errors as errorsen_risk } from './errorsResx.en_risk';
import { errors as errorses } from './errorsResx.es';
import { errors as errorsfr } from './errorsResx.fr';
import { errors as errorsit } from './errorsResx.it';
import { errors as errorsnl } from './errorsResx.nl';
import { errors as errorspl } from './errorsResx.pl';
import { errors as errorspt } from './errorsResx.pt';
import { errors as errorsru } from './errorsResx.ru';
import { errors as errorssk } from './errorsResx.sk';
import { errors as errorssv } from './errorsResx.sv';
import { errors as errorstr } from './errorsResx.tr';

const langMap: { [k: string]: Partial<typeof errorsen> } = {
    de: errorsde,
    en: errorsen,
    en_risk: errorsen_risk,
    es: errorses,
    fr: errorsfr,
    it: errorsit,
    nl: errorsnl,
    pl: errorspl,
    pt: errorspt,
    ru: errorsru,
    sk: errorssk,
    sv: errorssv,
    tr: errorstr,
};

/* tslint:disable: max-line-length */
export const errorsResx = {
    get attachment_already_added_error() {
        return langMap[ep.resxCulture].attachment_already_added_error || langMap.en.attachment_already_added_error;
    },
    get attachment_file_exists() {
        return langMap[ep.resxCulture].attachment_file_exists || langMap.en.attachment_file_exists;
    },
    get CanEditOrDeleteInvoice_LMD_Changed() {
        return langMap[ep.resxCulture].CanEditOrDeleteInvoice_LMD_Changed || langMap.en.CanEditOrDeleteInvoice_LMD_Changed;
    },
    get canManageProjectMembers_deny() {
        return langMap[ep.resxCulture].canManageProjectMembers_deny || langMap.en.canManageProjectMembers_deny;
    },
    get cannot_delete_error() {
        return langMap[ep.resxCulture].cannot_delete_error || langMap.en.cannot_delete_error;
    },
    get change_project_member_permissions() {
        return langMap[ep.resxCulture].change_project_member_permissions || langMap.en.change_project_member_permissions;
    },
    get csv_no_projects() {
        return langMap[ep.resxCulture].csv_no_projects || langMap.en.csv_no_projects;
    },
    get csv_no_role() {
        return langMap[ep.resxCulture].csv_no_role || langMap.en.csv_no_role;
    },
    get csv_no_task() {
        return langMap[ep.resxCulture].csv_no_task || langMap.en.csv_no_task;
    },
    get csv_no_user() {
        return langMap[ep.resxCulture].csv_no_user || langMap.en.csv_no_user;
    },
    get dates_empty() {
        return langMap[ep.resxCulture].dates_empty || langMap.en.dates_empty;
    },
    get disable_status_isUsed() {
        return langMap[ep.resxCulture].disable_status_isUsed || langMap.en.disable_status_isUsed;
    },
    get disable_status_isWorkflowType() {
        return langMap[ep.resxCulture].disable_status_isWorkflowType || langMap.en.disable_status_isWorkflowType;
    },
    get duration_exceed() {
        return langMap[ep.resxCulture].duration_exceed || langMap.en.duration_exceed;
    },
    get duration_invalid_format() {
        return langMap[ep.resxCulture].duration_invalid_format || langMap.en.duration_invalid_format;
    },
    get ErrorMessageLoggedUserChangedException() {
        return langMap[ep.resxCulture].ErrorMessageLoggedUserChangedException || langMap.en.ErrorMessageLoggedUserChangedException;
    },
    get errorRemoveProjectManager() {
        return langMap[ep.resxCulture].errorRemoveProjectManager || langMap.en.errorRemoveProjectManager;
    },
    get failedOperation() {
        return langMap[ep.resxCulture].failedOperation || langMap.en.failedOperation;
    },
    get field_required_template() {
        return langMap[ep.resxCulture].field_required_template || langMap.en.field_required_template;
    },
    get invalid_common() {
        return langMap[ep.resxCulture].invalid_common || langMap.en.invalid_common;
    },
    get invalid_csv_headers() {
        return langMap[ep.resxCulture].invalid_csv_headers || langMap.en.invalid_csv_headers;
    },
    get invalid_permission_to_delete() {
        return langMap[ep.resxCulture].invalid_permission_to_delete || langMap.en.invalid_permission_to_delete;
    },
    get invalid_permission_to_insert() {
        return langMap[ep.resxCulture].invalid_permission_to_insert || langMap.en.invalid_permission_to_insert;
    },
    get invalid_permission_to_update() {
        return langMap[ep.resxCulture].invalid_permission_to_update || langMap.en.invalid_permission_to_update;
    },
    get invalid_uploaded_avatar() {
        return langMap[ep.resxCulture].invalid_uploaded_avatar || langMap.en.invalid_uploaded_avatar;
    },
    get invalid_uploaded_csv() {
        return langMap[ep.resxCulture].invalid_uploaded_csv || langMap.en.invalid_uploaded_csv;
    },
    get invalid_uploaded_passwordwords() {
        return langMap[ep.resxCulture].invalid_uploaded_passwordwords || langMap.en.invalid_uploaded_passwordwords;
    },
    get invalid_xml() {
        return langMap[ep.resxCulture].invalid_xml || langMap.en.invalid_xml;
    },
    get no_file_selected() {
        return langMap[ep.resxCulture].no_file_selected || langMap.en.no_file_selected;
    },
    get no_permission_to_create_forms() {
        return langMap[ep.resxCulture].no_permission_to_create_forms || langMap.en.no_permission_to_create_forms;
    },
    get no_permission_to_create_projects() {
        return langMap[ep.resxCulture].no_permission_to_create_projects || langMap.en.no_permission_to_create_projects;
    },
    get no_permission_to_create_tasks() {
        return langMap[ep.resxCulture].no_permission_to_create_tasks || langMap.en.no_permission_to_create_tasks;
    },
    get no_permission_to_edit_in_this_space() {
        return langMap[ep.resxCulture].no_permission_to_edit_in_this_space || langMap.en.no_permission_to_edit_in_this_space;
    },
    get no_permission_to_edit_project_members() {
        return langMap[ep.resxCulture].no_permission_to_edit_project_members || langMap.en.no_permission_to_edit_project_members;
    },
    get no_permission_to_edit_task_assignees() {
        return langMap[ep.resxCulture].no_permission_to_edit_task_assignees || langMap.en.no_permission_to_edit_task_assignees;
    },
    get noProjectMember() {
        return langMap[ep.resxCulture].noProjectMember || langMap.en.noProjectMember;
    },
    get parent_task_not_found() {
        return langMap[ep.resxCulture].parent_task_not_found || langMap.en.parent_task_not_found;
    },
    get password_doesnt_meet_policy() {
        return langMap[ep.resxCulture].password_doesnt_meet_policy || langMap.en.password_doesnt_meet_policy;
    },
    get password_is_empty() {
        return langMap[ep.resxCulture].password_is_empty || langMap.en.password_is_empty;
    },
    get priority_duplicate_order_error() {
        return langMap[ep.resxCulture].priority_duplicate_order_error || langMap.en.priority_duplicate_order_error;
    },
    get project_billing_value_required() {
        return langMap[ep.resxCulture].project_billing_value_required || langMap.en.project_billing_value_required;
    },
    get project_import_invalid_file() {
        return langMap[ep.resxCulture].project_import_invalid_file || langMap.en.project_import_invalid_file;
    },
    get project_import_invalid_format() {
        return langMap[ep.resxCulture].project_import_invalid_format || langMap.en.project_import_invalid_format;
    },
    get project_import_invalid_mpp() {
        return langMap[ep.resxCulture].project_import_invalid_mpp || langMap.en.project_import_invalid_mpp;
    },
    get project_import_invalid_mpx() {
        return langMap[ep.resxCulture].project_import_invalid_mpx || langMap.en.project_import_invalid_mpx;
    },
    get project_import_invalid_structure() {
        return langMap[ep.resxCulture].project_import_invalid_structure || langMap.en.project_import_invalid_structure;
    },
    get project_import_no_project_manager() {
        return langMap[ep.resxCulture].project_import_no_project_manager || langMap.en.project_import_no_project_manager;
    },
    get project_no_customer_for_customer_billing() {
        return langMap[ep.resxCulture].project_no_customer_for_customer_billing || langMap.en.project_no_customer_for_customer_billing;
    },
    get project_row_size_error() {
        return langMap[ep.resxCulture].project_row_size_error || langMap.en.project_row_size_error;
    },
    get publicholidays_duplicate_name_error() {
        return langMap[ep.resxCulture].publicholidays_duplicate_name_error || langMap.en.publicholidays_duplicate_name_error;
    },
    get report_category_value_axis_req() {
        return langMap[ep.resxCulture].report_category_value_axis_req || langMap.en.report_category_value_axis_req;
    },
    get report_data_source_required() {
        return langMap[ep.resxCulture].report_data_source_required || langMap.en.report_data_source_required;
    },
    get report_name_required() {
        return langMap[ep.resxCulture].report_name_required || langMap.en.report_name_required;
    },
    get report_value_axis_req() {
        return langMap[ep.resxCulture].report_value_axis_req || langMap.en.report_value_axis_req;
    },
    get set_status_workflow_type_status_is_default() {
        return langMap[ep.resxCulture].set_status_workflow_type_status_is_default || langMap.en.set_status_workflow_type_status_is_default;
    },
    get task_cycle() {
        return langMap[ep.resxCulture].task_cycle || langMap.en.task_cycle;
    },
    get Task_Edit_Permission_Rescinded() {
        return langMap[ep.resxCulture].Task_Edit_Permission_Rescinded || langMap.en.Task_Edit_Permission_Rescinded;
    },
    get task_inconsistent_nested_milestones() {
        return langMap[ep.resxCulture].task_inconsistent_nested_milestones || langMap.en.task_inconsistent_nested_milestones;
    },
    get task_inconsistent_nested_milestones_task_name() {
        return langMap[ep.resxCulture].task_inconsistent_nested_milestones_task_name || langMap.en.task_inconsistent_nested_milestones_task_name;
    },
    get task_parent_deleted() {
        return langMap[ep.resxCulture].task_parent_deleted || langMap.en.task_parent_deleted;
    },
    get task_row_size_error() {
        return langMap[ep.resxCulture].task_row_size_error || langMap.en.task_row_size_error;
    },
    get task_start_date_lower_than_parent_error() {
        return langMap[ep.resxCulture].task_start_date_lower_than_parent_error || langMap.en.task_start_date_lower_than_parent_error;
    },
    get tasks_import_duration_format() {
        return langMap[ep.resxCulture].tasks_import_duration_format || langMap.en.tasks_import_duration_format;
    },
    get tasks_import_empty_name() {
        return langMap[ep.resxCulture].tasks_import_empty_name || langMap.en.tasks_import_empty_name;
    },
    get tasks_import_enddate_format() {
        return langMap[ep.resxCulture].tasks_import_enddate_format || langMap.en.tasks_import_enddate_format;
    },
    get tasks_import_invalid_csv_format() {
        return langMap[ep.resxCulture].tasks_import_invalid_csv_format || langMap.en.tasks_import_invalid_csv_format;
    },
    get tasks_import_startdate_format() {
        return langMap[ep.resxCulture].tasks_import_startdate_format || langMap.en.tasks_import_startdate_format;
    },
    get tasks_import_startdate_range() {
        return langMap[ep.resxCulture].tasks_import_startdate_range || langMap.en.tasks_import_startdate_range;
    },
    get tasks_import_unknown_parent() {
        return langMap[ep.resxCulture].tasks_import_unknown_parent || langMap.en.tasks_import_unknown_parent;
    },
    get thresholds_duplicate_value_error() {
        return langMap[ep.resxCulture].thresholds_duplicate_value_error || langMap.en.thresholds_duplicate_value_error;
    },
    get time_exceed() {
        return langMap[ep.resxCulture].time_exceed || langMap.en.time_exceed;
    },
    get time_invalid_format() {
        return langMap[ep.resxCulture].time_invalid_format || langMap.en.time_invalid_format;
    },
    get user_duplicate_email_error() {
        return langMap[ep.resxCulture].user_duplicate_email_error || langMap.en.user_duplicate_email_error;
    },
    get user_duplicate_login_error() {
        return langMap[ep.resxCulture].user_duplicate_login_error || langMap.en.user_duplicate_login_error;
    },
    get User_Is_Not_Assigneed() {
        return langMap[ep.resxCulture].User_Is_Not_Assigneed || langMap.en.User_Is_Not_Assigneed;
    },
    get user_licensing_limits_warning() {
        return langMap[ep.resxCulture].user_licensing_limits_warning || langMap.en.user_licensing_limits_warning;
    },
    get UserImport_InvalidEmailFormat() {
        return langMap[ep.resxCulture].UserImport_InvalidEmailFormat || langMap.en.UserImport_InvalidEmailFormat;
    },
    get UserNotIncludeInProject() {
        return langMap[ep.resxCulture].UserNotIncludeInProject || langMap.en.UserNotIncludeInProject;
    },
    get users_conversion() {
        return langMap[ep.resxCulture].users_conversion || langMap.en.users_conversion;
    },
    get users_customization() {
        return langMap[ep.resxCulture].users_customization || langMap.en.users_customization;
    },
    get users_lastAdmin() {
        return langMap[ep.resxCulture].users_lastAdmin || langMap.en.users_lastAdmin;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.errors = errorsResx;
